import type { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    Router,
    RouterStateSnapshot
} from '@angular/router';
import { map, take } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';
import { selectAuthToken } from '../store/auth.store';
import { RootState } from '../../store/store.state';

@Injectable()
export class AuthValidGuard {
    constructor(
        private store: Store<RootState>,
        private router: Router
    ) {}

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {
        return this.store.pipe(
            select(selectAuthToken),
            take(1),
            map((jwt) => {
                if (typeof jwt === 'string' && jwt.length > 0) {
                    return true;
                } else {
                    /* skipLocationChange => Navigates without pushing a new state into history */
                    this.router.navigate(['/auth'], {
                        queryParams: {
                            qssAppReturnUrl: state.url
                        },
                        skipLocationChange: true
                    });
                    return false;
                }
            })
        );
    }
}
